import { render, staticRenderFns } from "./TypeList.vue?vue&type=template&id=b0cb4f94&scoped=true"
import script from "./TypeList.vue?vue&type=script&lang=js"
export * from "./TypeList.vue?vue&type=script&lang=js"
import style0 from "./TypeList.vue?vue&type=style&index=0&id=b0cb4f94&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cb4f94",
  null
  
)

export default component.exports